import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadingBar from 'react-redux-loading-bar';
import { withLocalize } from 'react-localize-redux';
import Reports from 'containers/reports';
import { Navbar, ActionButton, Label, SmallDialog } from '../widgets';
import css from './Anonymous.css';
import toaster from '../../utils/toaster';

const Anonymous = ({
    reportType = '',
    showPasswordModal = false,
    translate = () => {},
    error = '',
    onPasswordInput = () => {},
}) => {
    const passwordInputRef = useRef(null);
    const toastIdRef = useRef(null);

    useEffect(() => {
        if (error) {
            if (toastIdRef.current) {
                toaster.dismiss(toastIdRef.current);
            }
            toastIdRef.current = toaster.toast(translate(translate(error)), { type: toaster.TYPE.ERROR });
        }
    }, [error]);

    const handleModalSubmit = () => {
        onPasswordInput(passwordInputRef.current.value);
    };

    return (
        <div className={css.container}>
            <LoadingBar updateTime={100} maxProgress={95} progressIncrease={1} className={css.loadingBar} />
            <Navbar promotionText={translate('STATIC.PAGES.ANONYMOUS.PROMOTION_TEXT')} />
            <Reports type={reportType} />
            <SmallDialog modal open={showPasswordModal}>
                <div className={css.modalContainer}>
                    <Label type="h1" text="STATIC.PAGES.ANONYMOUS.MODAL_TITLE" style={{ marginBottom: 24 }} />
                    <table>
                        <tbody>
                            <tr>
                                <td className={css.labelCell}>{translate('STATIC.PAGES.ANONYMOUS.MODAL_LABEL')}</td>
                                <td className={css.modalInputCell}>
                                    <input
                                        ref={passwordInputRef}
                                        type="text"
                                        placeholder={translate(translate('STATIC.PAGES.ANONYMOUS.MODAL_PLACEHOLDER'))}
                                        className={css.modalInput}
                                    />
                                </td>
                            </tr>
                            <tr className={css.rowSpacer} />
                            <tr>
                                <td />
                                <td>
                                    <ActionButton
                                        text="STATIC.BUTTONS.SUBMIT"
                                        containerClass={css.submitButton}
                                        onClick={handleModalSubmit}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </SmallDialog>
        </div>
    );
};

Anonymous.propTypes = {
    reportType: PropTypes.string,
    showPasswordModal: PropTypes.bool,
    onPasswordInput: PropTypes.func,
    error: PropTypes.string,
    translate: PropTypes.func,
};

export default withLocalize(Anonymous);
